import React, { FC } from 'react';
import useDeviceSize from '../../../../../../hooks/useDeviceSize';
import { accountSwitcherStyle } from '../../AccountSwitcher/AccountSwitcher.style';
import { Flex, Button, Text, Input, Form, Checkbox } from '../../../../../../components/Element';
import { useCreateAccount } from '../logic/useCreateAccount.logic';
import { BaseFormConfig, SignUpField, SubTypes } from '../../../../Auth/logic/Auth.types';
import { TERMS_OF_USE_FIELD_KEY, TermsOfUseLabel, termsOfUseRules } from '../../../../Auth/subcomponents/TermsOfUse/TermsOfUse';
import { signUpNameRules } from '../../../../Auth/logic/signUpNameRules';

type CreateAccountModalProps = {
  selectedConfig?: BaseFormConfig;
  fields: SignUpField[];
  types: SubTypes[];
  refetch?: () => any;
};

export const CreateAccountModal: FC<CreateAccountModalProps> = (props) => {
  const device = useDeviceSize();
  const style = accountSwitcherStyle(device);
  const { isLoading, doCompleteSignUp, selectedSubtype, selectSubAccountType, error } = useCreateAccount(props.refetch);
  return (
    <Flex vertical={true}>
      {props?.types ? (
        <Flex vertical={false} gap={6} style={style.typesHeader} justify="space-between">
          {props?.types.map((item: SubTypes) => (
            <Button
              style={selectedSubtype === item.value ? style.createAccountTypeButtonSelected : style.createAccountTypeButton}
              onClick={() => selectSubAccountType(item.value)}
            >
              {item.label}
            </Button>
          ))}
        </Flex>
      ) : (
        <></>
      )}
      <Form name="create-investor-account" onFinish={(values) => doCompleteSignUp(values)} layout="vertical" size="large">
        {props?.fields.map((field: SignUpField) => {
          switch (field.type) {
            case 'string': {
              // Only the two name fields have a rule. `aria-required` gives their
              // required state to assistive technology.
              const nameRules = signUpNameRules(field.key);
              return (
                <Form
                  key={field.key}
                  name={field.key}
                  defaultValue={field.defaultValue}
                  isFormItem={true}
                  label={<Text style={style.formLabel}>{field.placeHolder}</Text>}
                  style={style.formItem}
                  rules={nameRules}
                >
                  <Input placeholder={field.placeHolder} aria-required={nameRules ? true : undefined} />
                </Form>
              );
            }
            case 'checkbox':
              return (
                <Form
                  key={field.key}
                  name={field.key}
                  isFormItem={true}
                  style={style.formItemCheck}
                  valuePropName="checked"
                  rules={field.key === TERMS_OF_USE_FIELD_KEY ? termsOfUseRules : undefined}
                >
                  <Checkbox
                    style={style.checkboxB}
                    defaultChecked={field.defaultValue}
                    // The terms box has a rule. `aria-required` gives its required state
                    // to assistive technology.
                    aria-required={field.key === TERMS_OF_USE_FIELD_KEY ? true : undefined}
                  >
                    {field.key === TERMS_OF_USE_FIELD_KEY ? <TermsOfUseLabel linkStyle={style.linkBox} /> : field.text}
                  </Checkbox>
                </Form>
              );
            default:
              return <Text>Unimplemented field type {field?.['type']}</Text>;
          }
        })}
        <Button style={style.nextButton} loading={isLoading} htmlType="submit">
          Create
        </Button>
        {error[''] && error[''].length > 0 && (
          <ul style={{ color: 'red' }}>
            {error[''].map((err, i) => (
              <li>{err}</li>
            ))}
          </ul>
        )}
        <Text style={style.captchaText}>Protected by Google reCAPTCHA to ensure security.</Text>
      </Form>
    </Flex>
  );
};
